const BosniaAndHerzegovinaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110936)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 0C12.9086 0 6.67967 3.69086 3.12842 9.25617L30.2502 37.1757C36.0895 33.6834 40 27.2987 40 20C40 8.95437 31.0456 0 20 0Z"
        fill="#FFDA44"
      />
      <path
        d="M40.0001 19.9993C40.0001 14.81 38.0237 10.0829 34.7827 6.52832V33.4703C38.0237 29.9157 40.0001 25.1885 40.0001 19.9993Z"
        fill="#0052B4"
      />
      <path
        d="M24.9835 37.6466L27.0784 37.6453L27.7247 35.6524L28.3733 37.6445L29.4241 37.6439C30.0684 37.299 30.6916 36.9199 31.2913 36.5088L3.49133 8.70898C3.0332 9.37742 2.61539 10.0754 2.23969 10.7988L2.48672 11.5576L4.58164 11.5563L2.88758 12.7887L3.53617 14.7808L1.84055 13.5505L0.829219 14.2861C0.290078 16.0967 0 18.0146 0 20.0003C0 31.0459 8.95437 40.0003 20 40.0003C22.3353 40.0003 24.5768 39.5994 26.6602 38.8634L24.9835 37.6466ZM4.46086 19.1308L5.10695 17.138L3.41148 15.9075L5.50641 15.9062L6.15258 13.9133L6.80117 15.9054L8.89609 15.9041L7.20195 17.1365L7.85055 19.1286L6.15492 17.8983L4.46086 19.1308ZM8.77531 23.4786L9.42141 21.4858L7.72594 20.2553L9.82086 20.254L10.467 18.2611L11.1156 20.2532L13.2105 20.2519L11.5165 21.4843L12.1651 23.4764L10.4695 22.2461L8.77531 23.4786ZM13.0897 27.8264L13.7358 25.8336L12.0403 24.6031L14.1352 24.6018L14.7814 22.6089L15.43 24.601L17.5249 24.5997L15.8309 25.8321L16.4795 27.8242L14.7838 26.5938L13.0897 27.8264ZM19.0982 30.9418L17.4041 32.1742L18.0502 30.1814L16.3547 28.9509L18.4496 28.9496L19.0959 26.9567L19.7445 28.9488L21.8394 28.9475L20.1453 30.1799L20.7939 32.172L19.0982 30.9418ZM21.7185 36.522L22.3646 34.5292L20.6691 33.2987L22.7641 33.2974L23.4102 31.3045L24.0588 33.2966L26.1538 33.2953L24.4597 34.5277L25.1083 36.5198L23.4127 35.2894L21.7185 36.522Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110936">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BosniaAndHerzegovinaSvg;
